import AuthContext from "contexts/AuthContext"
import React, { useContext } from "react"
import { Button, Card, Form, Input, Loader, Message } from "semantic-ui-react"

import * as prohealth from "./prohealth-api"

export default function GetBalance() {

    const [cardNumber, setCardNumber] = React.useState<string>()
    const [loader, setLoader] = React.useState(false)
    /**
     * The balance card's contents, copied off the processor's reply — where both
     * fields are optional, hence the explicit `| undefined` on each. `null` is in
     * the state type because every failure arm clears it with `setBalance(null)`.
     */
    const [balance, setBalance] = React.useState<{ balance?: string | undefined; status?: string | undefined } | null>()
    const [error, setError] = React.useState<string | null>()

    // Raw context rather than `useAuthContext()`: the accessor throws when no
    // provider is present and this component currently does not.
    const authInfo = useContext(AuthContext)!

    const getBalance = async (cardNumber: string) => {
        await prohealth.balanceInquiry(authInfo.token, cardNumber)
            .then(
                (response) => {
                    setLoader(false)
                    if (response.data.status === 0) {
                        // `data` asserted throughout this branch — a `status: 0`
                        // reply that omitted it already threw here. See the
                        // envelope note in ./prohealth-api.ts.
                        if (response.data.data!.statusCode === 1) {
                            setBalance({ balance: response.data.data!.balance, status: response.data.data!.statusReason })
                            setError(null)
                        } else {
                            setError("ERROR: " + response.data.data!.statusReason)
                            setBalance(null)
                        }
                    }
                    else {
                        setError(response.data.message ?? "test error")
                        setBalance(null)
                    }
                },
                (error: Error) => {
                    setLoader(false)
                    setError(error.message)
                    setBalance(null)
                })
    }

    return (
        <>
            <Form>
                <Form.Field inline>
                    <Input style={{ "width": "250px" }} focus placeholder="Enter Solutran Card Number" onChange={(e) => setCardNumber(e.target.value)} />
                    {/*
                      * SUSPECTED DEFECT (the onClick below) — REPORTED, NOT FIXED.
                      * Nothing gates this button on `cardNumber` having been
                      * typed, and it is `useState<string>()`, so clicking it on a
                      * blank form calls `balanceInquiry(token, undefined)` and
                      * requests `…/balance-inquiry/undefined`. The loader is also
                      * set unconditionally here but only cleared inside the
                      * promise handlers, so the same click leaves the spinner up.
                      * Asserted rather than gated: adding the condition is the
                      * right fix and is a behaviour change.
                      */}
                    <Button primary icon='search' content='Get Balance' onClick={() => {
                        setLoader(true);
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- fire-and-forget balance lookup; a rejection leaves the loader spinning with no error shown
                        getBalance(cardNumber!)
                    }} />
                </Form.Field>
            </Form>

            {loader && <Loader style={{ "paddingTop": "10px" }} active inline="centered" />}

            {error &&
                <Card>
                    <Message error size="small" header={"Error!"} content={error} />
                </Card>
            }
            {balance &&
                <Card>
                    <Message success size="small" header={"Success!"} list={['Current Balance: $' + balance.balance, 'Status Reason: ' + balance.status]} />
                </Card>
            }
        </>
    )
}